export default class Term {
  constructor() {
    this.term = ""
    this.description = ""
    this.acronym = ""
  }
}
